import { render } from "./MyPagesBack.vue?vue&type=template&id=399eaf19"
import script from "./MyPagesBack.vue?vue&type=script&lang=js"
export * from "./MyPagesBack.vue?vue&type=script&lang=js"

import "./MyPagesBack.vue?vue&type=style&index=0&id=399eaf19&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__